module.exports = __webpack_public_path__ + "static/media/invisible_illness.bb3d23c6.gif";